module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-up-2a9a6b9349a5384da071ba9f033e807a.svg";